import * as React from 'react';
import { Toggletip } from '@grandvisionhq/lib-visuals';

const BannerTooltip = ({ className , tooltip  })=>{
    return /*#__PURE__*/ React.createElement(Toggletip, {
        className: className,
        message: tooltip.text,
        variant: tooltip.textColor === 'white' ? 'inverted' : 'default',
        "aria-label": tooltip.title,
        showLabel: true
    });
};

export { BannerTooltip };
//# sourceMappingURL=BannerTooltip.js.map
